import { ref } from "vue";

const visible = ref(false);
const message = ref("");
const type = ref<"success" | "error" | "confirm">("success");

let confirmCallback: ((result: boolean) => void) | null = null;

export function useToast() {

  function showToast(msg: string, t: "success" | "error" = "success") {
    message.value = msg;
    type.value = t;
    visible.value = true;

    setTimeout(() => {
      visible.value = false;
    }, 2000);
  }

  function confirmToast(msg: string): Promise<boolean> {
    message.value = msg;
    type.value = "confirm";
    visible.value = true;

    return new Promise((resolve) => {
      confirmCallback = resolve;
    });
  }

  function confirmYes() {
    visible.value = false;
    confirmCallback?.(true);
    confirmCallback = null;
  }

  function confirmNo() {
    visible.value = false;
    confirmCallback?.(false);
    confirmCallback = null;
  }

  return {
    visible,
    message,
    type,
    showToast,
    confirmToast,
    confirmYes,
    confirmNo,
  };
}